<div class="modal__header">
  <h1 mat-dialog-title>
    {{data.header}}
  </h1>
  <span class="material-icons" (click)="exitDialog()">close</span>
</div>
<div class="modal__content" id="addPerson" mat-dialog-content>
  <form [formGroup]="formOptions" (ngSubmit)="addCost()" #formDirective="ngForm">
    <mat-form-field class="example-full-width">
      <input type="text" placeholder="Nazwa kosztu" aria-label="Number"
        matInput formControlName="cost_name" >
      <mat-error *ngIf="formOptions.controls['cost_name'].errors?.required">
        Pole wymagane</mat-error>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input type="text" placeholder="Wpisz kwotę" aria-label="Number"
        matInput formControlName="cost_price" >
      <mat-error *ngIf="formOptions.controls['cost_price'].errors?.required">
        Pole wymagane</mat-error>
    </mat-form-field>
    <mat-checkbox color="primary" formControlName="isConfirmed">Koszt potwierdzony</mat-checkbox>
  </form>
</div>
<div class="modal__footer mat_buttons" mat-dialog-actions>
  <button mat-raised-button color="default" (click)="exitDialog()">Zamknij</button>
  <button mat-raised-button type="submit" color="primary" *ngIf="!data.cost" (click)="formDirective.ngSubmit.emit()" >Dodaj</button>
  <button mat-raised-button type="submit" color="primary" *ngIf="data.cost" (click)="editCost()" >Zapisz</button>
</div>
<div class="spinner_center fixed" *ngIf="invoiceLoading">
  <mat-spinner></mat-spinner>
</div>
